import { Box, Button, Card, IconButton, Modal, Stack, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import mapMarkerYellow from "../../assets/images/marker_yellow.png";
import { GoogleMap, Marker } from "@react-google-maps/api";
import NearMeIcon from "@mui/icons-material/NearMe";
import Getcurrentlocation from "../common/Getcurrentlocation";
import { useSelector, useDispatch } from "react-redux";
import { setSelectlocation } from "../../redux/actions/actions";
import SearchMap from "../sites/SearchMap";
import { English } from "../../constant/EnglishFallback";

export default function ChooseLocation() {
  const { selectLocation, multiLanguageData } = useSelector((state) => state?.main);
  const dispatch = useDispatch();

  const [disableLocation, setDisableLocation] = useState(true);
  const [location, setLocation] = useState({ lat: 0, lng: 0 });
  const [currentLocation, setCurrentlocation] = useState({ lat: 0, lng: 0 });
  const [mapTypeId, setMapTypeId] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");
  const [map, setMap] = useState(null);

  const mapRef = useRef(null);

  const {
    TEXT_CHOOSE_LOCATION = English?.ChooseLocation?.TEXT_CHOOSE_LOCATION,
    TEXT_SEARCH_MAP = English?.ChooseLocation?.TEXT_SEARCH_MAP,
    BUTTON_USE_CURRENT_LOCATION = English?.ChooseLocation?.BUTTON_USE_CURRENT_LOCATION,
    BUTTON_USING_CURRENT_LOCATION = English?.ChooseLocation?.BUTTON_USING_CURRENT_LOCATION
  } = multiLanguageData?.ChooseLocation || {};

  const containerStyle = {
    width: "100%",
    height: "400px"
  };

  const createCircleIcon = (color, radius) => ({
    path: window.google.maps.SymbolPath.CIRCLE,
    fillColor: color,
    fillOpacity: 0.4,
    strokeColor: "Blue",
    strokeOpacity: 20,
    strokeWeight: 40,
    scale: radius
  });

  useEffect(() => {
    getLocation();
    return () => {
      setSearchTerm("");
    };
  }, [selectLocation]);

  const getLocation = async () => {
    if (selectLocation?.lat && selectLocation?.lng) {
      setLocation({ lat: selectLocation.lat, lng: selectLocation.lng });
    } else {
      const { lat, lng } = await Getcurrentlocation();
      setLocation({ lat, lng });
      setCurrentlocation({ lat, lng });
    }
  };

  const handleClose = () => {
    let closeMapModal = {
      ...selectLocation,
      open: false,
      from: ""
    };
    dispatch(setSelectlocation(closeMapModal));
  };

  const submitLocation = () => {
    dispatch(
      setSelectlocation({
        ...selectLocation,
        open: false,
        lat: location.lat,
        lng: location.lng
      })
    );
  };

  const handleMapDrag = () => {
    if (mapRef.current) {
      const center = mapRef.current.getCenter();
      setLocation({ lat: center.lat(), lng: center.lng() });
    }
  };

  const getNearLocation = async () => {
    const { lat, lng } = await Getcurrentlocation();
    setLocation({ lat, lng });
    setCurrentlocation({ lat, lng });
    setDisableLocation(true);
  };

  const handleSearch = (place) => {
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    setLocation({ lat, lng });
    map.fitBounds(place.geometry.viewport);
  };

  const renderDisableLocation = () => {
    return location?.lat === currentLocation?.lat && location?.lng === currentLocation?.lng;
  };

  return (
    <Modal open={selectLocation?.open}>
      <Box className="user-modal-responsive choose-location">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}>
          <Typography className="add-title">{TEXT_CHOOSE_LOCATION}</Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <GoogleMap
          ref={mapRef}
          center={location}
          zoom={13}
          mapContainerStyle={containerStyle}
          mapContainerClassName="site-map-container"
          onLoad={(mapInstance) => {
            mapRef.current = mapInstance;
            setMap(mapInstance);
            mapInstance.setOptions({
              restriction: {
                latLngBounds: {
                  north: 85,
                  south: -85,
                  east: 180,
                  west: -180
                },
                strictBounds: false
              },
              styles: [
                { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
                { featureType: "poi", stylers: [{ visibility: "off" }], elementType: "all" },
                {
                  featureType: "road.highway",
                  elementType: "labels.text",
                  stylers: [{ visibility: "off" }]
                },
                {
                  featureType: "road.highway",
                  elementType: "labels.icon",
                  stylers: [{ visibility: "off" }]
                }
              ]
            });
          }}
          onUnmount={() => (mapRef.current = null)}
          onDragEnd={() => handleMapDrag()}
          onZoomChanged={() => handleMapDrag()}
          mapTypeId={
            mapTypeId === 0
              ? "roadmap"
              : mapTypeId === 1
                ? "hybrid"
                : mapTypeId === 2
                  ? "satellite"
                  : mapTypeId === 3
                    ? "terrain"
                    : ""
          }
          options={{
            disableDefaultUI: true,
            streetViewControl: false,
            fullscreenControl: false,
            zoomControl: false,
            mapTypeControl: false,
            minZoom: 3
          }}>
          <img
            className="mapIcon"
            src={mapMarkerYellow}
            alt="Center Marker"
            style={{ height: "35px" }}
          />
          <Marker position={currentLocation} icon={createCircleIcon("#4285F4", 5)} />
        </GoogleMap>

        <Card
          className="searchText-Box-Container"
          sx={{ borderRadius: "25px", border: "1px solid #e3e3e3" }}>
          <SearchMap
            setSearchTerm={setSearchTerm}
            searchTerm={searchTerm}
            handleSearch={handleSearch}
            from="map"
            placeholder={TEXT_SEARCH_MAP}
          />
        </Card>

        <Stack spacing={1}>
          <Button
            disabled={renderDisableLocation()}
            variant="text"
            fullWidth
            sx={{ color: renderDisableLocation() ? "gray" : "#083DB8" }}
            onClick={getNearLocation}>
            <NearMeIcon
              fontSize="small"
              sx={{ color: renderDisableLocation() ? "gray" : "#083DB8", mr: 1 }}
            />
            {renderDisableLocation()?BUTTON_USING_CURRENT_LOCATION:BUTTON_USE_CURRENT_LOCATION}
          </Button>
          <Button
            variant="contained"
            fullWidth
            sx={{ backgroundColor: "#083DB8" }}
            onClick={submitLocation}>
            {TEXT_CHOOSE_LOCATION}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}
